import { z } from "zod"

export const SpreadsheetSchema = z.object({
  id: z.number(),
  name: z.string(),
  modified_time: z.string().optional(),
})

export type Spreadsheet = z.infer<typeof SpreadsheetSchema>
